import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import DeviationMediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
export function getAttachmentType(attachment) {
    if ('mp4' in attachment) {
        return 'gif';
    }
    if ('isVideo' in attachment) {
        return 'video';
    }
    if ('image' in attachment) {
        return 'image';
    }
    if ('msg' in attachment) {
        return 'quote';
    }
    if ('type' in attachment) {
        return 'file';
    }
    if ('title' in attachment) {
        return 'nonImage';
    }
    return 'nonImage';
}
export function isGifAttachment(attachment) {
    return getAttachmentType(attachment) === 'gif';
}
export function isImageDeviationAttachment(attachment) {
    return getAttachmentType(attachment) === 'image';
}
export function isNonImageDeviationAttachment(attachment) {
    return getAttachmentType(attachment) === 'nonImage';
}
export function isQuoteAttachment(attachment) {
    return getAttachmentType(attachment) === 'quote';
}
export function isFileAttachment(attachment) {
    return getAttachmentType(attachment) === 'file';
}
export function isVideoAttachment(attachment) {
    return getAttachmentType(attachment) === 'video';
}
export function factoryAttachmentFromDeviationAndType(deviation, extType) {
    // TODO this should be based on extType
    const type = DeviationMediaService.getDeviationType(deviation);
    switch(type){
        case DeviationTypes.UNKNOWN:
            return {
                link: deviation.url,
                type: extType,
                title: deviation.title
            };
        case DeviationTypes.COMMISSION:
        case DeviationTypes.JOURNAL:
        case DeviationTypes.LITERATURE:
        case DeviationTypes.TIER:
        case DeviationTypes.PDF:
        case DeviationTypes.STATUS:
        case DeviationTypes.POLL:
            return {
                link: deviation.url,
                title: deviation.title
            };
        case DeviationTypes.IMAGE:
        case DeviationTypes.FILM:
            const media = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, 400, 266, (thumbs)=>thumbs[thumbs.length - 1]);
            return {
                image: media === null || media === void 0 ? void 0 : media.src,
                width: media === null || media === void 0 ? void 0 : media.width,
                height: media === null || media === void 0 ? void 0 : media.height,
                link: deviation.url
            };
        default:
            return undefined;
    }
}

//# sourceMappingURL=attachments.js.map